export default __webpack_public_path__ + "static/media/team4.b3e7fb2c.jpg";